export default "__VITE_ASSET__houJdoAb__"